import { RESOLVE_APP, RESOLVE_APP_ERROR, RESOLVE_APP_SUCCESS, SET_HOST_STATE } from "./constants";

import produce from "immer";

// The shops are wallmektools.com (en_US) and wallmek.co.uk (en_GB). wallmek.se is catalogue-only
// in both Swedish (sv_SE) and English for the EU market (en_SE). en_GB only counts as a shop
// together with GBP: until the production row for www.wallmek.se/en is switched to en_SE it is
// still en_GB with SEK, and this guard keeps it catalogue-only through that deploy window.
const isShop = (locale, currencyCode) =>
    locale === "en_US" || (locale === "en_GB" && (currencyCode || "").toUpperCase() === "GBP");

// The initial state of this store.
const initialState = {
    isFetching: false,
    applicationId: null,
    currentHref: "",
    origin: "",
    currentPathname: "/",
    pathBeforeStore: "/",
    customer: null,
    applicationName: null,
    path: null,
    config: {},
    priceGroups: [],
    currency: null,
    languages: [],
    locale: null,
    ecommerceEnabled: false,
    state: null,
    device: null,
    defaultPriceList: {
        id: 1,
        code: "",
    },
};

export default produce((state, action) => {
    switch (action.type) {
        case RESOLVE_APP:
            state.isFetching = true;
            break;
        case RESOLVE_APP_SUCCESS:
            state.isFetching = false;
            state.applicationId = action.application.id;
            state.applicationName = action.application.name;
            state.path = action.application.path;
            state.config = action.config;
            state.priceGroups = action.priceGroups;
            state.currency = action.currency;
            state.languages = action.languages;
            state.locale = action.application.locale;
            state.ecommerceEnabled = isShop(action.application.locale, action.currency?.code);
            state.device = action.device;
            state.defaultPriceList = action.defaultPriceList;
            break;
        case RESOLVE_APP_ERROR:
            state.isFetching = false;
            break;
        case SET_HOST_STATE:
            state.currentHref = action.currentHref;
            state.origin = action.origin;
            state.currentPathname = action.currentPathname;
            state.protocol = action.protocol;
            state.isSupportingWebp = action.isSupportingWebp;
            state.ipAddress = action.ipAddress;
            break;
        default:
            break;
    }
}, initialState);
